import { BackIcon } from 'assets/icons';
import { FC, useEffect, useState } from 'react';
import { JobStatus } from '../constant';
import { RadioWithLabel } from 'components';
import { getAvailableJobStatuses, getJobStatusColor } from '../utils';
import ChevronArrowRightReactIcon from 'assets/react-icons/ChevronArrowRightReactIcon';
import { WebAppColors } from 'constants/colors';
import { selectCurrentTeamJobPermissions, selectMerchantCustomizations } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks/typedHooks';

interface EditStatusPanelProps {
  status: JobStatus;
  onBackClick: () => void;
  handleStatusChange: (jobStatus: JobStatus) => void;
}

const EditStatusPanel: FC<EditStatusPanelProps> = ({ status, onBackClick, handleStatusChange }) => {
  const [jobStatusList, setJobStatusList] = useState([]);
  const jobPermissions = useAppSelector(selectCurrentTeamJobPermissions);
  const { teamConfigs } = useAppSelector(selectMerchantCustomizations);

  useEffect(() => {
    const availableStatuses = getAvailableJobStatuses(status, jobPermissions, teamConfigs);
    setJobStatusList(availableStatuses);
  }, [status, jobPermissions, teamConfigs]);

  return (
    <div className="h-full w-96">
      <div className="mb-1 flex items-center border-b border-secondaryBtn py-4">
        <BackIcon className="mx-4 cursor-pointer" id="job-details-panel-back-arrow" onClick={onBackClick} />
        <div className="text-17px font-semibold text-headingGray">Status</div>
      </div>
      <div>
        {jobStatusList.map((jobStatus, index) => (
          <div
            key={jobStatus.value}
            className={`flex items-center justify-between  py-5 px-4
            ${index !== jobStatusList.length - 1 && 'border-b border-secondaryBtn'}`}
            onClick={() => handleStatusChange(jobStatus.value)}>
            <RadioWithLabel
              isSelected={jobStatus.value === status}
              label={jobStatus.label}
              onClick={() => null}
              labelStyle={{ color: getJobStatusColor(jobStatus.value) }}
            />
            {jobStatus.value !== status && (
              <ChevronArrowRightReactIcon id={`edit-status-panel-${jobStatus.value}`} fill={WebAppColors.Gray_1} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditStatusPanel;
